import React, { useState, useEffect, useRef, useContext } from 'react';
import axios from 'axios';
import { FaBell } from 'react-icons/fa';
import { LoginContext } from '../../Contexts/LoginContext';
import { useNavigate } from 'react-router-dom';

export default function NotificationPopup() {
  const [notifications, setNotifications] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef(null);
  const { isLogin } = useContext(LoginContext);
  const navigate = useNavigate();

  const fetchNotifications = async () => {
    if (!isLogin) return;
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/notifications`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNotifications(response.data);
    } catch (error) {
      console.error('Failed to fetch notifications', error);
    }
  };

  const markNotificationsAsRead = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/notifications/read`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchNotifications();
    } catch (error) {
      console.error('Failed to mark notifications as read', error);
    }
  };

  const togglePopup = () => {
    setIsOpen(!isOpen);
    if (!isOpen)
      markNotificationsAsRead();
  };

  useEffect(() => {
    if (isLogin) {
      fetchNotifications();
      const interval = setInterval(fetchNotifications, 30000);
      return () => clearInterval(interval);
    }
  }, [isLogin]);

  useEffect(() => {
    const onVisible = () => { if (document.visibilityState === 'visible') fetchNotifications(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target) && isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const unreadCount = notifications.filter(n => !n.isRead).length;

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / (1000 * 60));
    if (minutes < 1) return 'just now';
    if (minutes < 60) return `${minutes} min ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hr ago`;
    const days = Math.floor(hours / 24);
    return `${days} days ago`;
  };

  return (
    <div className="notificationPopupContainer" ref={popupRef}>
      <div className="notificationIconWrapper">
        <FaBell size={22} className="notificationIcon" onClick={togglePopup} />
        {unreadCount > 0 && (
          <span className="notificationItemCount">{unreadCount}</span>
        )}
      </div>

      {isOpen && (
        <div className="popupContainer">
          <div className="popup">
            <div className="triangle"></div>
            <div className="popupHeader">
              <h2>Notifications</h2>
            </div>
            {notifications.length === 0 ? (
              <div className="no-items">No notifications</div>
            ) : (
              <div className="notificationList">
                {notifications.map((notification) => (
                  <div
                    key={notification.id}
                    className={`notificationItem ${notification.isRead ? 'read' : 'unread'}`}
                    style={notification.link ? { cursor: 'pointer' } : {}}
                    onClick={() => {
                      if (notification.link) {
                        setIsOpen(false);
                        navigate(notification.link);
                      }
                    }}
                  >
                    <p>{notification.content}</p>
                    <span className="notificationTime">{formatTime(notification.createdAt)}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}